const linkButtonVariables = new Map<string, { var: string; cssVar?: string; assignDefault?: string[] }>([
  [
    'linkButtonColor',
    {
      var: 'components.linkButton.default.color.text.initial',
      cssVar: 'link-button-color',
      assignDefault: ['linkButtonHoverColor', 'linkButtonActiveColor'],
    },
  ],
  [
    'linkButtonHoverColor',
    {
      var: 'components.linkButton.default.color.text.hover',
      cssVar: 'link-button-hover-color',
    },
  ],
  [
    'linkButtonActiveColor',
    {
      var: 'components.linkButton.default.color.text.active',
      cssVar: 'link-button-active-color',
    },
  ],
  [
    'linkButtonDestructiveColor',
    {
      var: 'components.linkButton.destructive.color.text.initial',
      cssVar: 'link-button-destructive-color',
      assignDefault: ['linkButtonDestructiveHoverColor', 'linkButtonDestructiveActiveColor'],
    },
  ],
  [
    'linkButtonDestructiveHoverColor',
    {
      var: 'components.linkButton.destructive.color.text.hover',
      cssVar: 'link-button-destructive-hover-color',
      assignDefault: ['linkButtonDestructiveActiveColor'],
    },
  ],
  [
    'linkButtonDestructiveActiveColor',
    {
      var: 'components.linkButton.destructive.color.text.active',
      cssVar: 'link-button-destructive-active-color',
    },
  ],
]);

export default linkButtonVariables;
